import { useNavigationStore, useServiceResponse, useUserInput } from '@store';
import { useFetchSubscriptionMaintenance, useFetchSubscriptionIntegratedSolution } from '@services';
import {
	CommercialPckgType,
	CredentialType,
	PromoCodeStatus,
	SubscriptionIntegratedSolutionInputDto,
	SubscriptionMaintenanceContabInputDto,
	SubscriptionMaintenanceContabOutputDto,
} from '@api/izibizi-xp';
import { UseFetchServiceSuccessResult } from '@bcp-channels-sharedcomponents-reactjs/core/dist/$hooks';
import { getSessionStorage } from '@helpers';

interface SubscriptionMaintenanceInput {
	token: string;
}
interface SubscriptionMaintenanceOutput {
	fetchSubscription: () => Promise<UseFetchServiceSuccessResult<SubscriptionMaintenanceContabOutputDto>>;
}

export const useSubscription = (props: SubscriptionMaintenanceInput): SubscriptionMaintenanceOutput => {
	const { token } = props;
	const { fetch: fetchSubscriptionMaintenance } = useFetchSubscriptionMaintenance();
	const { fetch: fetchSubscriptionIntegratedSolution } = useFetchSubscriptionIntegratedSolution();
	const { retrievePromoCodeDetail } = useServiceResponse();
	const codeStatus = retrievePromoCodeDetail?.promoCodeStatus;
	const promoCode = retrievePromoCodeDetail?.promoCodeDetail?.code;
	const isSubCodeValid = codeStatus === PromoCodeStatus.ACTIVE ? true : false;
	const { flow } = useNavigationStore();
	const processId = getSessionStorage<string>('processId');
	const {
		acceptedDebitInAccount,
		acceptedTermsAndConditionsBank,
		acceptedTermsAndConditionsSoftware,
		email,
		promotionalCode,
		planId,
		solutionId,
		selectedAccount,
	} = useUserInput();

	const fetchSubscription = () => {
		if (flow === 'subscription') {
			const data: SubscriptionMaintenanceContabInputDto = {
				acceptCloudwareDocument: acceptedTermsAndConditionsSoftware,
				acceptDebitInAccount: acceptedDebitInAccount,
				acceptMillenniumDocument: acceptedTermsAndConditionsBank,
				email: email,
				plan: planId,
				//if promoCodeStatus !== 'valid' send undefined
				promotionalCode: isSubCodeValid ? promoCode : undefined,
				accountId: selectedAccount?.account.id,
				credentialCode: token,
				credentialType: CredentialType.Sms,
				processId: processId,
			};
			return fetchSubscriptionMaintenance(data);
		} else {
			const packageInput =
				solutionId === '201'
					? CommercialPckgType.IziBiziIntegratedSolutionPlanPremium
					: CommercialPckgType.IziBiziIntegratedSolutionPlanDefault;
			const data: SubscriptionIntegratedSolutionInputDto = {
				accountId: selectedAccount?.account.id,
				package: packageInput,
				acceptCGDocument: acceptedTermsAndConditionsBank,
				credentialType: CredentialType.Sms,
				credentialCode: token,
				email: email,
			};
			return fetchSubscriptionIntegratedSolution(data);
		}
	};

	return { fetchSubscription };
};
